import { ReactNode } from 'react';
import { Stack } from './Stack';
import { Text } from './Text';

export function EmptyState({ title, hint, action }: { title: string; hint?: string; action?: ReactNode }) {
  return (
    <div className="hairline rounded-sm py-8 px-3 text-center">
      <Stack gap={2} className="items-center">
        <Text variant="small" muted>{title}</Text>
        {hint && <Text variant="label">{hint}</Text>}
        {action}
      </Stack>
    </div>
  );
}
